import React, { Fragment, useContext, useEffect, useState } from 'react';
import { bool } from 'prop-types';
import { Image } from 'react-bootstrap';

import useLayout from '@context/layout/useLayout';
import { OverlayTrigger, Tooltip } from '@ajaibid/components';
import ProfileMenu from '@screens/ProfileMenu';
import useStockProfile from '@hooks/profile/useStockProfile';
import { AuthContext } from '@context/auth';
import { rightPanelItems } from '../RightPanel';
import {
  styNavbarBox,
  styNavbarMenu,
  styNavbarlist,
  styIconProfile,
  styProfileMenu,
  styNavbarContent,
  styNavbarProfile,
} from './style';

const RightNav = ({ profileOnly }) => {
  const { rightPanel } = useLayout();
  const { imgProfile, isPremium, isPremiumTrial, fetchPrimeTrial, primeTrialData } =
    useStockProfile();
  const { stockKycVerified, stockKycError } = useContext(AuthContext);
  const [profileActive, setProfileActive] = useState(false);
  const toggleProfile = () => setProfileActive(!profileActive);

  useEffect(() => {
    if (profileOnly) {
      rightPanel.hide();
    }
  }, [profileOnly]);

  const renderMenuItems = () =>
    rightPanelItems.map(({ icon: Icon, id, tooltip }, i) => {
      const isActive = rightPanel.itemKey === id;
      const handleClick = () => {
        if (isActive) {
          rightPanel.hide();
        } else {
          rightPanel.show(id);
        }
      };

      return (
        <li key={i} className={styNavbarBox}>
          {!profileOnly && (
            <OverlayTrigger placement="left" overlay={<Tooltip>{tooltip}</Tooltip>}>
              <div className={styNavbarContent({ isActive })} onClick={handleClick}>
                <Icon isActive={isActive} />
              </div>
            </OverlayTrigger>
          )}
        </li>
      );
    });

  const renderProfileMenu = () => (
    <>
      <OverlayTrigger placement="left" overlay={<Tooltip>Profil Saya</Tooltip>}>
        <div className={styNavbarProfile} onClick={toggleProfile}>
          <Image className={styIconProfile({ profileActive, isPremium })} src={imgProfile} />
        </div>
      </OverlayTrigger>
      {profileActive && (
        <div className={styProfileMenu}>
          <ProfileMenu
            imgProfile={imgProfile}
            isPremium={isPremium}
            isPremiumTrial={isPremiumTrial}
            fetchPrimeTrial={fetchPrimeTrial}
            primeTrialData={primeTrialData}
            stockKycVerified={stockKycVerified}
            stockKycError={stockKycError}
          />
        </div>
      )}
    </>
  );

  return (
    <nav className={styNavbarMenu}>
      <ul className={styNavbarlist}>{renderMenuItems()}</ul>

      {renderProfileMenu()}
    </nav>
  );
};

RightNav.propTypes = {
  profileOnly: bool,
};

RightNav.defaultProps = {
  profileOnly: false,
};

export default RightNav;
